export const WORKSPACE_TYPES = {
  EXERCISE: 'exercise',
  INCIDENT: 'incident',
} as const;

export type WorkspaceType =
  (typeof WORKSPACE_TYPES)[keyof typeof WORKSPACE_TYPES];
